import styles from './Radio.module.scss';
import React, { forwardRef } from 'react';
import { Button, Radio as BaseRadio } from '@ariakit/react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

const Radio = forwardRef(
  (
    {
      disabled = false,
      error = false,
      id = null,
      label,
      store = null,
      value = '',
      variant = null,
      ...props
    },
    ref,
  ) => (
    <label
      className={classNames(styles.container, styles[variant], {
        [styles.disabledContainer]: disabled,
      })}
      htmlFor={id}
      id={id ? `${id}-label` : null}
    >
      <BaseRadio
        className={styles.input}
        disabled={disabled}
        id={id}
        ref={ref}
        store={store}
        tabIndex={-1}
        value={value}
        {...props}
      />
      <Button
        aria-checked={props?.checked}
        aria-labelledby={id ? `${id}-label` : label}
        className={classNames(styles.circle, {
          [styles[variant]]: variant,
          [styles.error]: error,
          [styles.disabled]: disabled,
        })}
        render={<span />}
        role="radio"
      />
      {label}
    </label>
  ),
);

Radio.propTypes = {
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  id: PropTypes.string,
  /** Label for the radio button */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  /* eslint-disable react/forbid-prop-types */
  /** `useRadioStore()` return value from `@ariakit/react` */
  store: PropTypes.object,
  /** Value of the radio button */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  variant: PropTypes.oneOf(['horizontal']),
  /* eslint-enable react/forbid-prop-types */
};

Radio.displayName = 'Radio';

export default Radio;
